import React, { FC, PropsWithChildren } from 'react'
import { Modal } from 'styles/modals'

const FullScreen: FC<PropsWithChildren> = ({ children }) => {
  return <Modal data-type='fullscreen'>{children}</Modal>
}

export default FullScreen
